import { useDispatch, useSelector } from 'react-redux';
import { getSpinnerShowPolygons } from 'src/store/spinner/selectors';
import { useCallback, useRef } from 'react';
import { Actions } from 'src/store/spinner/actions';

export const usePolygonsSwitch = () => {
  const showPolygons = useSelector(getSpinnerShowPolygons);
  const showPolygonsRef = useRef<boolean>(showPolygons);
  showPolygonsRef.current = showPolygons;
  const dispatch = useDispatch();
  const changePolygonsVisibility = useCallback((value: boolean) => {
    dispatch(Actions.setSpinnerShowPolygons(value));
  }, []);

  const togglePolygonsVisibility = useCallback(() => {
    dispatch(Actions.setSpinnerShowPolygons(!showPolygons));
  }, [showPolygons]);
  return {
    showPolygons,
    showPolygonsRef,
    changePolygonsVisibility,
    togglePolygonsVisibility,
  };
};
